import React from 'react';
import { Switch as AntSwitch } from 'antd';

interface SwitchFieldProps {
  checked?: boolean;
  onChange?: (checked: boolean) => void;
  [key: string]: any;
}

export const SwitchField: React.FC<SwitchFieldProps> = ({
  checked = false,
  onChange,
  ...props
}) => {
  return <AntSwitch checked={checked} onChange={onChange} {...props} />;
};
